// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3jGHv","list":"PatternAutocomplete_list__1R_-p"};